<template>
  <div class="my-weiper-container" :class="{ 'my-weiper-container-mob': !isPC }">
    <div class="hide">
      <!-- 为了预加载所有图片 -->
      <img src="https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/swiper2/p1.png" alt="">
      <img src="https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/swiper2/p2.png" alt="">
      <img src="https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/swiper2/p3.png" alt="">
      <img src="https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/swiper2/m1.png" alt="">
      <img src="https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/swiper2/m2.png" alt="">
      <img src="https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/swiper2/m3.png" alt="">
    </div>
    <div class="title" :class="{ 'title-mob': !isPC }">
      <!-- <div class="title-pre">震撼的动力性能</div> -->
      <div class="title-main">卓越性能，带来全新动感体验</div>
    </div>
    <div class="swiper-container" @mouseleave="mouseleave">
      <div class="swiper-wrapper">
        <div class="swiper-slide" :class="{ 'swiper-slide-mob': !isPC }" v-for="(item, index) in imgs" :key="index">
          <div class="imgBox">
            <img :src="item.imgPC" alt="" :data-index="index">
            <!-- <div v-if="showCoverBox" class="coverBox"></div> -->
          </div>
          <div class="title">{{ item.title }}</div>
          <div class="text">{{ item.text }}</div>
          <!-- <img :code-stm="`event, PAGEURL页面, 查看详情${item.img}`" v-if="item.video" :data-index="index" class="icon-play" :class="{'icon-play-mob': !isPC}" src="../assets/images/play.png" alt=""> -->
        </div>
      </div>
      <div class="swiper-pagination" @mouseenter="mouseleave" :class="{ 'swiper-pagination-mob': !isPC }"></div>
    </div>

    <div class="cover" v-if="isShowCover">
      <i class="el-icon-close" v-if="!isShowVideo" :class="{ 'el-icon-close-mob': !isPC }" @click="hideCover"
        :code-stm="`event, PAGEURL页面, 关闭弹窗`"></i>
      <i class="el-icon-close" v-else :class="{ 'el-icon-close-mob': !isPC }" @click="hideVideo"
        :code-stm="`event, PAGEURL页面, 关闭视频`"></i>
      <div class="pop" v-show="!isShowVideo">
        <div class="swiper-container2" :class="{ 'swiper-container2-mob': !isPC }">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in imgs" :key="index + 'cover'">
              <img :src="item.imgPCBig" :data-pop-Index="index" alt=""
                :code-stm="`event, PAGEURL页面, 弹窗视频播放${item.video}`">
              <img class="icon-play  icon-play-2" :data-pop-index="index"
                :code-stm="`event, PAGEURL页面, 弹窗视频播放${item.video}`" v-if="item.video" src="../assets/images/play.png"
                alt="">
            </div>
          </div>
        </div>
        <!-- Add Pagination -->
        <div class="swiper-pagination swiper-pagination2"></div>
        <!-- Add Arrows -->
        <div class="swiper-button-next swiper-button-next2" :code-stm="`event, PAGEURL页面, 弹窗轮播下一页`"></div>
        <div class="swiper-button-prev swiper-button-prev2" :code-stm="`event, PAGEURL页面, 弹窗轮播上一页`"></div>
      </div>
      <div class="pop-video" :class="{ 'pop-video-mob': !isPC }" v-if="isShowVideo">
        <video class="my-video" :src="videoSrc" autoplay="true" loop="false" muted="false" direction="0" controls></video>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import { isPortraitFun, getUrlKey, isPc, maidian } from "@/utils/utils.js";
export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      isPC: isPc(),
      isShowCover: false,
      swiperCover: null,
      imgs: [
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/swiper2/p3.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/swiper2/m3.png',
          title: '0-100km/h 3.5秒',
          text: "EV6 GT为您带来爆发性加速动力，最高时速达260公里的强大行驶性能，从静止到时速100公里只需3.5秒",
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/swiper2/p1.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/swiper2/m1.png',
          title: '电子限滑差速器(e-LSD) /电子控制悬架系统(ECS)',
          text: '电子限滑差速器能够主动控制左右轮的动力输出，提高高速转弯时的操控力并且弥补动力损失。此外，电子控制悬架系统能够根据行驶模式实现稳定舒适的乘坐感受和优异的操控性能',
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/swiper2/p2.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/swiper2/m2.png',
          title: '前轮大口径制动卡钳（4活塞）',
          text: "前轮配备大口径4活塞制动卡钳，更大的轮盘制动器带来符合高性能车辆的制动力",
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/swiper2/p4.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/swiper2/m4.png',
          title: '21英寸铝合金镜面轮毂',
          text: "21英寸动感设计的轮毂、高性能轮胎及荧光色卡钳，带来强烈的视觉冲击，提供了稳定的运动感驾驶体验",
        },
        {
          imgPC: 'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/swiper2/p5.png',
          imgMob: 'https://www.kia.cn/assets/~/media/images/vehicle/ev6/swipers/swiper2/m5.png',
          title: 'GT驾驶模式',
          text: "EV6 GT“Sport+”驾驶模式可以对电机、制动器、转向系统、减震器、电子限滑差速器。(e-LSD)和车身稳定系统(ESC)进行优化设置，以提高车辆的加速性能、驾驶操控性",
        }
      ],
      showCoverBox: false,
      isShowVideo: false,
      videoSrc: "",
    };
  },
  mounted: function () {
    let that = this;
    let preIndex = 3;
    this.$nextTick(() => {
      if (this.isPC) {
        var swiper = new Swiper('.swiper-container', {
          init: false,
          slideToClickedSlide: true,
          slidesPerView: 3,
          spaceBetween: 32,
          centeredSlides: true,
          loop: true,
          observer: true,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
          on: {
            // slideChange: function () {
            //   maidian("卓越性能，带来全新动感体验-"+that.imgs[this.realIndex].title)
            // },
            // slideChange: function(){
            //   // console.log('改变了，activeIndex为'+this.activeIndex);
            //   const len = that.imgs.length
            //   that.imgs.forEach((item, index) => {
            //     item.img = item.imgPC
            //   });
            //   if (this.activeIndex >= 3) {
            //     that.imgs[(this.activeIndex-3) % len].img = that.imgs[(this.activeIndex-3) % len].imgMob
            //     // console.log(that.imgs[(this.activeIndex-3)%5].img);
            //     // console.log(that.imgs[(this.activeIndex-3)%5].imgPC);
            //   }
            //   if (this.activeIndex == 7 && this.activeIndex > preIndex) {
            //     swiper.slideTo(3, 0)
            //   } else if (this.activeIndex == 2 && this.activeIndex < preIndex) {
            //     swiper.slideTo(this.activeIndex + len, 0)
            //   }
            //   // console.log(preIndex);
            //   preIndex = this.activeIndex
            // },
          },
          mousewheel: false
        });
        swiper.init();
        swiper.on('slideChange', function() {
          maidian("卓越性能，带来全新动感体验-"+that.imgs[this.realIndex].title)
        });
        window.addEventListener("click", this.showCover)
        // 获取所有slides和swiper容器
        let slides = document.querySelectorAll('.swiper-slide');
        let swiperContainer = document.querySelector('.swiper-container');
        slides.forEach((slide) => {
          slide.addEventListener('mouseenter', function () {
            // 鼠标进入当前slide，其他slide保持半透明
            slides.forEach((element) => {
              if (element !== slide) {
                element.style.opacity = '0.5';
              } else {
                element.style.opacity = 1;
              }
            });
          });
        });
      } else {
        var swiper = new Swiper('.swiper-container', {
          init: false,
          slidesPerView: 1,
          spaceBetween: 0,
          centeredSlides: true,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '#swiper-button-next',
            prevEl: '#swiper-button-prev',
          },
          on: {
            // slideChange: function () {
            //   maidian("卓越性能，带来全新动感体验-"+that.imgs[this.realIndex].title)
            // },
          }
        });
        swiper.init();
        swiper.on('slideChange', function() {
          maidian("卓越性能，带来全新动感体验-"+that.imgs[this.realIndex].title)
        });
        // window.addEventListener("click", this.showCover)
      }
      // this.swiperCover = new Swiper('.swiper-container2', {
      //   slidesPerView: 1,
      //   spaceBetween: 0,
      //   loop: false,
      //   pagination: {
      //     el: '.swiper-pagination2',
      //     type: 'fraction'
      //   },
      //   navigation: {
      //     nextEl: '.swiper-button-next2',
      //     prevEl: '.swiper-button-prev2',
      //   },
      // });
    })
  },
  methods: {
    mouseleave() {
      let slides = document.querySelectorAll('.swiper-slide');
      slides.forEach((element) => {
        console.log(element.style.opacity);
        element.style.opacity = 1;
      });
    },
    showCover(e) {
      return
      const index = e.target.getAttribute('data-index')
      // console.log(index);
      if (index) {
        this.isShowCover = true
        this.$nextTick(() => {
          this.swiperCover = new Swiper('.swiper-container2', {
            initialSlide: index,
            slidesPerView: 1,
            spaceBetween: 0,
            loop: false,
            pagination: {
              el: '.swiper-pagination2',
              type: 'fraction'
            },
            navigation: {
              nextEl: '.swiper-button-next2',
              prevEl: '.swiper-button-prev2',
            },
          });
        })
        // window.removeEventListener("click",this.showCover)

        // window.addEventListener("click",this.showVideo)
      }
    },
    hideCover() {
      this.isShowCover = false
      this.swiperCover = null
      window.addEventListener("click", this.showCover)
      window.removeEventListener("click", this.showVideo)
      this.hideVideo()
    },

    showVideo(e) {
      const index = e.target.getAttribute('data-pop-index')
      // console.log(index);
      if (this.imgs[index].video) {
        this.videoSrc = this.imgs[index].video
        this.isShowVideo = true
      }
    },
    hideVideo() {
      this.videoSrc = ""
      this.isShowVideo = false
    }
  },
};
</script>

<style lang="scss" scoped>
@import "swiper/css/swiper.css";

.my-weiper-container {
  position: relative;
  height: 100%;
  width: 100%;
  user-select: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #05141F;

  .hide {
    position: absolute;
    top: -999px;
    left: -999px;
    opacity: 0;
  }

  .title {
    text-align: center;
    margin-top: 4.8958vw;
    margin-bottom: 2.5vw;
    color: #05141F;

    &-mob {
      margin-top: 96px;
      margin-bottom: 32px;
    }

    &-pre {
      font-size: 1.25vw;
      margin-bottom: 1.25vw;
      opacity: 0.8;
    }

    &-main {
      font-size: 2.5vw;
      font-family: chuhei;
    }
  }

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
    height: auto;
  }

  .swiper-container {
    position: relative;
    width: 80%;
    height: 38vw;
    padding-bottom: 45px;
  }

  @media (max-width: 768px) {
    .title {
      padding: 0 25px;

      &-pre {
        font-size: 16px;
        margin-bottom: 12px;
      }

      &-main {
        font-size: 24px;
      }
    }

    .swiper-container {
      width: 100%;
      height: 150vw;

      .swiper-slide-active,
      .swiper-slide {
        transform: scale(1);
        .imgBox {
          padding-top: 0;
          img {
            aspect-ratio: unset;
            object-fit: unset;
          }
        }
      }

      .swiper-slide-active,
      .swiper-slide-duplicate-active {
        transform: scale(1);

        .imgBox {
          padding-top: 0;
          img {
            aspect-ratio: unset;
            object-fit: unset;
          }
        }

        .text {
          display: block;
        }
      }
    }
  }

  .swiper-slide {
    /* text-align: center; */
    /* font-size: 18px; */
    /* background: #eee; */
    /* display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center; */
    cursor: pointer;
    transition: all 300ms;

    .title {
      font-family: chuhei;
      font-size: 1.05vw;
      color: #05141F;
      line-height: 1.875vw;
      width: 100%;
      text-align: center;
      margin: 1.041vw 0 0.833vw;
      white-space: pre-line;
      text-align: left;
    }

    .text {
      text-align: left;
      display: none;
      font-size: 0.9375vw;
      color: rgba(5, 20, 31, 0.8);
      line-height: 1.4583vw;
    }

    /* .icon-play {
      width: 10%!important;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -100%);
      &-2 {
        transform: translate(-50%, -50%);
      }
      &-mob {
        top: calc(50% - 10px);
      }
    } */
    .imgBox {
      width: 100%;
      position: relative;
      padding-top: 5vw;
      img {
        width: 100%;
        aspect-ratio: 16/9;
        object-fit: cover;
      }

      .coverBox {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.6);
      }

      &:hover {
        .coverBox {
          opacity: 0;
        }
      }
    }

    &-mob {
      transform: scale(1);
    }
  }

  .swiper-slide-active,
  .swiper-slide {
    transform: scale(0.9);
    /* img {
    } */
  }

  .swiper-slide-active,
  .swiper-slide-duplicate-active {
    transform: scale(1);

    .imgBox {
      padding-top: 0;
      img {
        width: 100%;
        aspect-ratio: 1/1;
        object-fit: cover;
      }
    }

    .text {
      display: block;
    }
  }

  .swiper-container-horizontal>.swiper-pagination-progressbar,
  .swiper-container-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
    top: unset;
    height: 2px;
    bottom: 0;
  }

  ::v-deep .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
    background: #05141f !important;
  }

  ::v-deep .swiper-container-horizontal>.swiper-pagination-bullets {
    .swiper-pagination-bullet {
      width: 12px;
      height: 12px;
      border: 1px solid #05141F;
      background: #fff;
      border-radius: 50%;
      opacity: 1;
    }

    .swiper-pagination-bullet-active {
      width: 12px;
      height: 12px;
      opacity: 1;
      background: #05141F;
    }
  }

  .swiper-button-next,
  .swiper-button-prev {
    width: 2.91666vw;
    height: 2.91666vw;
    background: rgba($color: #fff, $alpha: 0.8);
    transition: all .5s;
    color: #fff;
    font-size: 30px;
    font-weight: bold;
    transform: translateY(-50%);

    &::after {
      /* content: none; */
      font-size: 16px;
      font-weight: 900;
      color: rgba(5, 20, 31, 0.8);
    }

    &:hover {
      background: rgba($color: #05141F, $alpha: 0.8);
    }

    &:hover::after {
      color: rgba(255, 255, 255, 0.8);
    }
  }

  .swiper-button-prev,
  .swiper-button-next:focus {
    outline: none;
  }

  .swiper-button-next {
    right: 2%;
  }

  .swiper-button-prev {
    left: 2%;
  }

  &-mob {
    padding: 0;

    .swiper-slide {
      .title {
        font-size: 18px;
        line-height: 26px;
        padding: 0 20px;
        margin-top: 24px;
      }

      .text {
        padding: 0 20px;
        font-size: 16px;
        line-height: 24px;
      }
    }

    ::v-deep .swiper-container-horizontal>.swiper-pagination-bullets {
      .swiper-pagination-bullet {
        width: 8px;
        height: 8px;
      }
    }

    .swiper-button-mob {
      width: 30px;
      height: 30px;
      background: rgba($color: #000000, $alpha: 0);
      color: #fff;
      font-size: 30px;
      font-weight: bold;
      top: calc(50% - 30px);
      transform: translateY(0);

      &::after {
        font-size: 16px;
        font-weight: 900;
        color: #fff;
      }

      &:hover {
        background: rgba($color: #000000, $alpha: 0);
      }

      &:hover::after {
        color: #fff;
      }
    }
  }

  /* @media screen and (orientation: portrait) {
    padding: 20px 0 25px;
    .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {
      bottom: -20px;
    }
  } */

  .cover {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: #000000;
    z-index: 10;

    .el-icon-close {
      color: #fff;
      font-size: 40px;
      cursor: pointer;
      position: absolute;
      z-index: 99;
      right: 50px;
      top: 50px;

      &-mob {
        font-size: 30px;
        right: 20px;
      }
    }

    .pop {
      position: relative;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .pop-video {
      width: 60%;
      height: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      &-mob {
        width: 100%;
      }

      video {
        width: 100%;
      }
    }

    .swiper-container2 {
      width: 70vw;
      height: auto;
      overflow: hidden;

      /* position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      overflow: hidden; */
      /* height: 80%; */
      .swiper-slide {
        background: rgba($color: #000000, $alpha: 0);

        img {
          width: 78%;
          height: auto;
        }

        @media (max-width: 768px) {
          img {
            width: 100%;
          }
        }

        .icon-play {
          width: 5% !important;
        }

        @media (max-width: 768px) {
          .icon-play {
            width: 10% !important;
          }
        }
      }

      &-mob {
        width: 100vw;
      }
    }

    .swiper-pagination-fraction {
      position: absolute;
      z-index: 999;
      bottom: -30px;
      color: #fff;
    }

    .swiper-button-next,
    .swiper-button-prev {
      background: rgba($color: #000, $alpha: 0);
      transition: all .5s;
      color: #fff;
      font-size: 30px;
      font-weight: bold;
      transform: translateY(-50%);

      &::after {
        /* content: none; */
        font-size: 30px;
        font-weight: 400;
        color: #fff;
      }

      &:hover {
        background: rgba($color: #05141F, $alpha: 0);
      }

      &:hover::after {
        color: #fff;
      }
    }

    .swiper-button-prev,
    .swiper-button-next:focus {
      outline: none;
    }

    .swiper-button-next2 {
      right: 0;
      transform: translateY(-25%);
    }

    .swiper-button-prev2 {
      left: 0;
      transform: translateY(-25%);
    }

    @media (max-width: 768px) {
      .swiper-button-next2 {
        width: auto;
        height: auto;
        right: 2%;
        transform: translateY(25%);
      }

      .swiper-button-prev2 {
        width: auto;
        height: auto;
        left: 2%;
        transform: translateY(25%);
      }
    }
  }
}</style>
